import { Capacitor } from "@capacitor/core";
import { openUrl } from "@/utils/openUrl";
import { ensureSubscriptionUrl } from "@/services/subscriptionLink";

export default {
  methods: {
    openSubscriptionUrl() {
      const { subscriptionUrl } = this.$store.state.subscription;

      if (subscriptionUrl) return openUrl(subscriptionUrl);

      // Pre-open a blank window synchronously within the user gesture context.
      // Without this, Safari blocks window navigation in async (.then) callbacks.
      // An empty URL is safe — it won't trigger Universal Links.
      const win = Capacitor.isNativePlatform() ? null : window.open("", "_blank");

      ensureSubscriptionUrl(this.$store).then((url) => {
        if (url) {
          win ? win.location = url : openUrl(url);
        } else {
          win?.close();
        }
      });
    },
  },
};
